import {appFetch, AppFetchResponse} from "../utils/appFetch";

const getDashboardBoxes = (days: number, selectedDomain: string, customDates?: { from: Date, to: Date }): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `statistics/dashboard-boxes/${days}?domain=${selectedDomain}${customDates?.from && customDates?.to ? `&from=${customDates.from}&to=${customDates.to}` : ''}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}

export default getDashboardBoxes;